import { UserType } from '../types';

const roles = [
  { value: UserType.ADMIN, title: 'admin' },
  { value: UserType.MANAGER, title: 'manager' },
  { value: UserType.ORGANIZER, title: 'organizer' },
];

export { roles };
